import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import SelectField from '../../../_common/platform/tsx/SelectField';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import NumberSpinner from '../../../_common/platform/tsx/NumberSpinner';
import { IAttributeSorting, SortType } from '../ts/Interfaces';

export default function AttributeSortingSelect(props: {
    value: IAttributeSorting;
    hideSortOrder?: boolean;
    showSortOnValuesAlways?: boolean;

    onChange(value: IAttributeSorting): void;
    onSortOrderSet?(value: number): void;
}) {
    const getValueCopy = (): IAttributeSorting => {
        return _.clone(props.value || {}) as IAttributeSorting;
    };

    const processValueChange = (value: IAttributeSorting) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleOnSortChange = (value: string) => {
        const valueCopy = getValueCopy();

        if (value === 'none') {
            delete valueCopy.sort;
        } else {
            valueCopy.sort = value as SortType;
        }

        processValueChange(valueCopy);
    };

    const handleOnSortOrderChange = (value: number) => {
        if (typeof props.onSortOrderSet === 'function') {
            props.onSortOrderSet(value);
        }
    };

    const handleOnSortValuesChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        valueCopy.sortOnValues = value;
        processValueChange(valueCopy);
    };

    const getSort = () => {
        const displayVal = props.value.sort || 'none';
        const options = _.map(['asc', 'desc'], (value, i) => {
            return (
                <option key={value + '-' + i} value={value}>
                    {value}
                </option>
            );
        });

        return (
            <SelectField value={displayVal} onChange={handleOnSortChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}
            </SelectField>
        );
    };

    const getSortOrder = () => {
        if (props.value.sort == null) {
            return;
        }

        return <NumberSpinner value={props.value.sortOrder} onChange={handleOnSortOrderChange} />;
    };

    const getSortOnValues = () => {
        if (props.value.sort == null && !props.showSortOnValuesAlways) {
            return;
        }

        return (
            <BooleanField
                title={''}
                value={props.value.sortOnValues}
                allowNull={false}
                onChange={handleOnSortValuesChange}
            />
        );
    };

    let sortOrder: React.JSX.Element;

    if (props.hideSortOrder !== true) {
        sortOrder = <td className="cell-sort-order">{getSortOrder()}</td>;
    }

    return (
        <div className="attribute-sorting-select">
            <table className="table">
                <tbody>
                    <tr>
                        <td className="cell-sort">{getSort()}</td>
                        {sortOrder}
                        <td className="cell-sort-on-values">{getSortOnValues()}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export function AttributeSortingSelectHeader(props: { hideSortOrder?: boolean }) {
    let sortOrder: React.JSX.Element;

    if (props.hideSortOrder !== true) {
        sortOrder = <th className="cell-sort-order">{'Sort Order'}</th>;
    }

    return (
        <div className="attribute-sorting-select">
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-sort">{'Sort'}</th>

                        {sortOrder}

                        <th className="cell-sort-on-values">{'Sort On Values'}</th>
                    </tr>
                </thead>
            </table>
        </div>
    );
}

export function normalizeSorting(attributes: IAttributeSorting[]) {
    if (attributes == null || attributes.length === 0) {
        return;
    }

    const sort = attributes.filter((attribute) => {
        return attribute.sort != null;
    });

    sort.sort((a, b) => {
        return a.sortOrder - b.sortOrder;
    });

    sort.forEach((attribute, index) => {
        attribute.sortOrder = index + 1;
    });
}

export function processSortSet(index: number, order: number, attributes: IAttributeSorting[]) {
    if (attributes == null || attributes.length === 0) {
        return;
    }

    const currentAttribute = attributes[index];

    let maxSortOrder = 0;

    attributes.forEach((attribute) => {
        if (attribute.sortOrder != null && maxSortOrder < attribute.sortOrder) {
            maxSortOrder = attribute.sortOrder;
        }
    });

    if (order == null || order > maxSortOrder) {
        order = maxSortOrder + 1;
    }

    const find = attributes.find((attribute) => {
        return attribute.sortOrder === order;
    });

    if (find != null) {
        find.sortOrder = currentAttribute.sortOrder || maxSortOrder + 1;
    }

    currentAttribute.sortOrder = order;
    normalizeSorting(attributes);
}
